import React, {useEffect, useState} from "react";
import useReadAccountBeforePaymentList from "../hooks/useReadAccountBeforePaymentList";
import {useLocation, useParams, useSearchParams} from "react-router-dom";
import {AccountSearchInterface} from "../../list/interface/searchInterface";
import EmptyTableRow from "../../../../common/EmptyTableRow";
import {Shipment} from "../interface";
import moment from "moment";
import PaginationSub from "../../../../../components/common/pagination/PaginationSub";
import DisplayNumber from "../../../../../components/common/number/DisplayNumber";

/**
 * 이전 결제건 탭
 * @param props
 * @returns
 */
export const BeforeApprovalTab = () => {
    const page = Number(useSearchParams()[0].get("pageNo")) || 1;
    const location = useLocation();
    const {id} = useParams();
    const isShowButton = !location.pathname.includes("beforeApproval");

    const defaultSearchValue = {
        keyword: "",
        keywordType: "0",
        limit: 10,
        pageNo: 1,
    };

    const [searchOption, setSearchOption] =
        useState<AccountSearchInterface>(defaultSearchValue);

    const {data} = useReadAccountBeforePaymentList({
        searchOption: {
            pageNo: Number(searchOption?.pageNo),
            limit: 10,
            newLEnduserValue: id ? id : "",
        },
    });

    const dataList = data?.list;
    const totalCount = data?.totalCount;

    useEffect(() => {
        setSearchOption({...searchOption, pageNo: page});
    }, [page]);

    const openNewTab = () => {
        window.open(
            process.env.PUBLIC_URL + "/customer/correspondent/beforeApproval/" + id,
            "_blank"
        );
    };

    return (
        <>
            <div className="content_wrap">
                <div className="table_top">
                    <h6 className="table_stats">
                        결제 건 목록(<span>{totalCount}</span>건)
                    </h6>
                    {isShowButton && (
                        <div className="table_toolbar">
                            <button
                                className="btn btn-info w-110px"
                                onClick={() => {
                                    openNewTab();
                                }}
                            >
                                새창에서 보기
                            </button>
                        </div>
                    )}
                </div>

                <div className="table_scroll">
                    <table className="table table-bordered my_table">
                        <thead>
                        <tr>
                            {/* 내부수정: 사이즈 변경 */}
                            <th style={{width: "7%"}}>주문일자</th>
                            <th style={{width: "15%"}}>주문번호</th>
                            <th>품목</th>
                            <th style={{width: "15%"}}>규격</th>
                            <th style={{width: "4%"}}>환종</th>
                            <th style={{width: "5%"}}>환율</th>
                            <th style={{width: "8%"}}>단가</th>
                            <th style={{width: "5%"}}>수량</th>
                            <th style={{width: "9%"}}>금액</th> 
                        </tr>
                        </thead>
                        <tbody>
                        {dataList?.length === 0 ? (
                            <EmptyTableRow colSpan={9}/>
                        ) : (
                            dataList?.map((el: Shipment) => {
                                if (el.orderSubjectResList.length === 0) {
                                    return <tr>
                                        <td className="text-center">
                                            {moment(el.newDtOrder).format("YYYY-MM-DD")}
                                        </td>
                                        <td className="text-center">{el.orderNo}</td>
                                        <td className="text-center"></td>
                                        <td className="text-center"></td>
                                        <td className="text-center"></td>
                                        <td className="text-center"></td>
                                        <td className="text-center"></td>
                                        <td className="text-center"></td>
                                        <td className="text-center"></td>
                                    </tr>
                                } else {
                                    return el.orderSubjectResList.map((el2, idx) => {
                                        return <tr>
                                            {idx === 0 && <>
                                                <td className="text-center" rowSpan={el.orderSubjectResList.length}>
                                                    {moment(el.newDtOrder).format("YYYY-MM-DD")}
                                                </td>
                                                <td className="text-center" rowSpan={el.orderSubjectResList.length}>
                                                    {el.orderNo}
                                                </td>
                                            </>}
                                            <td className="text-center">{el2.newTxtNmItem}</td>
                                            <td className="text-center">
                                                {el2.new_txt_standard}
                                            </td>
                                            <td className="text-center">{el2.currencyName}</td>
                                            <td className="text-center">
                                                <DisplayNumber value={el2.new_d_exchange_rate ?? 0}/>
                                            </td>
                                            <td className="text-center">
                                                <DisplayNumber value={el2.new_d_unitprice}/>
                                            </td>
                                            <td className="text-center">
                                                <DisplayNumber value={el2.new_i_qty}/></td>
                                            <td className="text-center">
                                                <DisplayNumber value={el2.new_d_total}/></td>
                                        </tr>
                                    })
                                }
                            })
                        )}
                        </tbody>
                    </table>
                </div>

                <PaginationSub totalCount={totalCount ?? 0}
                               currentPage={Number(searchOption.pageNo)}
                               onChangeCallback={(i) =>
                                   setSearchOption({...searchOption, pageNo: i})
                               }/>
            </div>
        </>
    );
};
